export default __webpack_public_path__ + "static/media/logo.4bc1832b.png";